export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes';
export const TIMEOUT_SEC = 20;
export const RES_PER_PAGE = 5;
export const KEY = '1abccb16-ff74-471c-9c20-7f67aa7461e1';
export const MODAL_CLOSE_SEC = 2.5;


